import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Anchor, Breadcrumbs, Button, Center, Group, Skeleton, Stack, Table, Text } from "@mantine/core";
import { useEffect, useMemo, useState } from "react";
import { PlusIcon } from '@phosphor-icons/react';
import { Link, useNavigate } from "react-router";
export default function Children() {
    var _a = useState(null), children = _a[0], setChildren = _a[1];
    var navigate = useNavigate();
    useEffect(function () {
        fetch('/api/children', {
            method: 'GET'
        })
            .then(function (res) {
            if (res.status === 401) {
                navigate('/login');
            }
            return res;
        })
            .then(function (res) { return res.json(); })
            .then(function (res) {
            setChildren(res);
        });
    }, []);
    var rows = useMemo(function () {
        if (children === null) {
            return _jsxs(Table.Tr, { children: [_jsx(Table.Td, { children: _jsx(Skeleton, { width: "100%", height: "100%" }) }), _jsx(Table.Td, { children: _jsx(Skeleton, { width: "100%", height: "100%" }) })] }, "loading-row");
        }
        if (children.length === 0) {
            return _jsx(Table.Tr, { children: _jsx(Table.Td, { colSpan: 2, children: _jsx(Center, { py: "xl", children: _jsx(Stack, { align: "center", gap: "xs", children: _jsx(Text, { size: "sm", fw: 500, children: "You have not added any children yet." }) }) }) }) }, "loading-row");
        }
        return children.map(function (row) {
            return _jsxs(Table.Tr, { children: [_jsx(Table.Td, { children: _jsx(Anchor, { component: Link, to: "/children/".concat(row.uuid), fz: "sm", children: row.name }) }), _jsx(Table.Td, { children: row.speechItems.length })] }, row.name);
        });
    }, [children]);
    return _jsxs("div", { children: [_jsx(Breadcrumbs, { children: [
                    _jsx(Text, { size: "sm", c: "dimmed", children: "Home" }, 0),
                ] }), _jsx("h1", { children: "Children" }), _jsx(Group, { justify: "flex-end", mb: "md", children: _jsx(Button, { component: Link, to: "/children/new", leftSection: _jsx(PlusIcon, { size: 16 }), children: "Add Child" }) }), _jsx(Table.ScrollContainer, { minWidth: 300, children: _jsxs(Table, { layout: "fixed", highlightOnHover: true, verticalSpacing: "xs", children: [_jsx(Table.Thead, { children: _jsxs(Table.Tr, { children: [_jsx(Table.Th, { children: "Name" }), _jsx(Table.Th, { style: { width: "20%" }, children: "Words" })] }) }), _jsx(Table.Tbody, { children: rows })] }) })] });
}
